import { render, staticRenderFns } from "./field-list-item.vue?vue&type=template&id=20b66fc8&scoped=true&"
import script from "./field-list-item.vue?vue&type=script&lang=js&"
export * from "./field-list-item.vue?vue&type=script&lang=js&"
import style0 from "./field-list-item.vue?vue&type=style&index=0&id=20b66fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b66fc8",
  null
  
)

export default component.exports